import React, { useEffect, useRef, useCallback } from "react";
import "./main-page.css";
import { disableScroll, enableScroll } from "../../utils/scroll-disabling/scroll-disabling";

export const MainPage = () => {
  const [showBluetoothIcon, setBluetoothIcon] = React.useState(false);
  const [showScreenshotsSection, setShowScreenshotsSection] =
    React.useState(false);
  const devicesSectionRef = useRef<HTMLDivElement>(null);
  const tabletRef = useRef<HTMLImageElement>(null);
  const tabletHolderRef = useRef<HTMLDivElement>(null);
  const tabletContainerRef = useRef<HTMLDivElement>(null);
  const modemRef = useRef<HTMLImageElement>(null);
  const bluetoothRef = useRef<HTMLImageElement>(null);
  const screenshotsRef = useRef<HTMLDivElement>(null);
  const secondScreenshotsRef = useRef<HTMLDivElement>(null);
  const thirdScreenshotsRef = useRef<HTMLDivElement>(null);
  const firstTextRef = useRef<HTMLHeadingElement>(null);
  const secondTextRef = useRef<HTMLHeadingElement>(null);
  const thirdTextRef = useRef<HTMLHeadingElement>(null);
  const initialScale = 2.2;
  const minScale = 0.7;
  const scaleDuration = 500;
  let previousScrollTop = useRef(0);
  let isTabletAnimationCompleted = useRef(false);

  const handleDevicesAnimation = useCallback(() => {
    const vh = window.innerHeight / 100;
    const currentScrollTop =
      document.documentElement.scrollTop || window.scrollY;
    const startScale = 0;
    const stopScale = 89 * vh;
    const startTranslate = 90 * vh;

    if (
      tabletContainerRef.current &&
      currentScrollTop > startScale &&
      currentScrollTop < stopScale &&
      !isTabletAnimationCompleted.current
    ) {
      const scale = Math.max(
        initialScale - (currentScrollTop - startScale) / scaleDuration,
        minScale
      );
      tabletContainerRef.current.style.transform = `scale(${scale})`;
    }
    if (tabletHolderRef.current && tabletRef.current && !isTabletAnimationCompleted.current) {
      if (currentScrollTop >= startTranslate) {

        setBluetoothIcon(true);
        if (!isTabletAnimationCompleted.current) {
          disableScroll();
        }
        tabletHolderRef.current.style.position = "sticky";
        tabletHolderRef.current.style.top = "15vh";
        if (tabletRef.current) {
          tabletRef.current.style.transform = `translateX(25%)`;
        }
        if (modemRef.current) {
          modemRef.current.style.transform = `translateX(0)`;
        }
        setTimeout(() => {
          if (bluetoothRef.current) {
            bluetoothRef.current.style.opacity = `1`;
          }
        }, 500);
        if (!isTabletAnimationCompleted.current) {
          setTimeout(() => {
            enableScroll();
          }, 1000);
        }
        isTabletAnimationCompleted.current = true;
      }
    }


    previousScrollTop.current = currentScrollTop;
  }, []);

  const handleScreenshotsAnimation = useCallback(() => {
    window.addEventListener("scroll", () => {
      if (screenshotsRef.current) {
        const rect = screenshotsRef.current.getBoundingClientRect();
        const isSticky = rect.top <= 500;

        if (isSticky) {
          setShowScreenshotsSection(true);
          if (
            secondScreenshotsRef.current &&
            thirdScreenshotsRef.current &&
            firstTextRef.current &&
            secondTextRef.current &&
            thirdTextRef.current
          ) {
            secondScreenshotsRef.current.style.transition = "transform 1s";
            thirdScreenshotsRef.current.style.transition = "transform 2s";
            secondScreenshotsRef.current.classList.add("sticky-active");
            thirdScreenshotsRef.current.classList.add("sticky-active");
            firstTextRef.current.style.transform = "translate(0%, 0%)";
            secondTextRef.current.style.transform = "translate(0%, 0%)";
            thirdTextRef.current.style.transform = "translate(0%, 0%)";
            firstTextRef.current.style.transition = "transform 1s";
            secondTextRef.current.style.transition = "transform 1.5s";
            thirdTextRef.current.style.transition = "transform 2s";
          }
        }
      }
    });
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleDevicesAnimation);
    window.addEventListener("scroll", handleScreenshotsAnimation);

    return () => {
      window.removeEventListener("scroll", handleDevicesAnimation);
      window.removeEventListener("scroll", handleScreenshotsAnimation);
    };
  }, [handleDevicesAnimation, handleScreenshotsAnimation]);

  return (
    <div className="main-page-container">
      <section className="devices-section" ref={devicesSectionRef}>
        <div ref={tabletHolderRef} className="tablet-holder">
          <div ref={tabletContainerRef} className="tablet-container">
            <img
              ref={modemRef}
              className="modem"
              src={require("../../images/Mobilink.png")}
              alt="модем"
            />
            {showBluetoothIcon && (
              <img
                ref={bluetoothRef}
                className="bluetooth-icon"
                src="/images/BluetoothLogoRounded.svg"
                alt="Bluetooth иконка"
              />
            )}
            <img
              ref={tabletRef}
              className="tablet"
              src={require("../../images/Tablet.png")}
              alt="планшет"
            />
            <div className="tablet-mock"></div>
          </div>
        </div>
      </section>
      <div>
        <div className="line"></div>
      </div>
      <section className="screenshots-section">
        <div className="screenshots-wrapper">
          <div ref={screenshotsRef} className="screenshots-container">
            <div className="card">
              <img
                className="screenshot"
                src={require("../../images/procomsol1.png")}
                alt="скриншот интерфейса планшета"
              />
            </div>
            {showScreenshotsSection && (
              <div ref={secondScreenshotsRef} className="card">
                <img
                  className="screenshot"
                  src={require("../../images/procomsol2.png")}
                  alt="скриншот интерфейса планшета"
                />
              </div>
            )}
            {showScreenshotsSection && (
              <div ref={thirdScreenshotsRef} className="card">
                <img
                  className="screenshot"
                  src={require("../../images/procomsol3.png")}
                  alt="скриншот интерфейса планшета"
                />
              </div>
            )}
          </div>
          {showScreenshotsSection && (
            <div className="device-description">
              <h3 className="description" ref={firstTextRef}>
                Взрывозащищённый <span className="different-color"> HART </span>
                коммуникатор
              </h3>
              <h3 className="description" ref={secondTextRef}>
                Встроенная база,
                <span className="different-color"> более 2300 </span>
                содержащая устройств
              </h3>
              <h3 className="description" ref={thirdTextRef}>
                Возможность добавлять новые<span className="different-color"> DD </span>
                файлы
              </h3>
            </div>
          )}
        </div>
      </section>
      <div>
        <div className="line"></div>
      </div>
      <section className="section">
        <h2 className="tablet__heading">Готовим для вас кое-что еще...</h2>
        <div className="new">
          <img
            className="new-tablet"
            src={require("../../images/20.png")}
            alt="новый планшет"
          />
          <img
            className="new-tablet-hard"
            src={require("../../images/21.png")}
            alt="новый планшет"
          />
        </div>
      </section>
    </div>
  );
};

export default MainPage;
